import React from 'react'
import { graphql, compose } from 'react-apollo'
import moment from 'moment'
import ReactHTMLConverter from 'react-html-converter'

import ListItem from './listItem'
import Conversation from './Conversation.jsx'
import CREATE_CONVERSATION from '../../graphql/Chat/CreateConversation.graphql'
import CREATE_MESSAGE from '../../graphql/Chat/CreateMessage.graphql'
import UPDATE_MESSAGE from '../../graphql/Chat/UpdateMessage.graphql'
import USERS from '../../graphql/Users.graphql'
import CONVERSATIONS_LIST from '../../graphql/Chat/ConversationsByUser.graphql'
import _ from 'lodash'

const converter = new ReactHTMLConverter()
converter.registerComponent('test', ConversationList)

class ConversationList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      conversation: false,
      messageText: '',
      usersShown: false
    }
  }

  componentWillMount() {
    if (this.props.single) {
      this.setState({
        conversation: true,
        selectedConversation: this.props.selectedConversation
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedConversation) {
      this.setState({
        selectedConversation: nextProps.selectedConversation
      })
    }
  }

  componentDidUpdate() {
    if (this.props.data) {
      this.props.data.refetch()
    }
  }

  showUsers = () => {
    this.setState({
      usersShown: !this.state.usersShown
    })
  }

  showConversation = conversation => {
    this.setState(
      {
        selectedConversation: conversation
      },
      () => {
        this.props.updateParentState(this.state)
        this.setState({
          conversation: !this.state.conversation
        })
      }
    )
  }

  showConversationList = () => {
    this.setState({ conversation: false })
  }

  goToConversation(user) {
    console.log('go', this.props, user)
    if (this.props.conversationsList.allConversations) {
      const filtredConversations = this.props.conversationsList.allConversations.filter(
        item => item.users.filter(item => item.id === user.id).length > 0
      )
      if (filtredConversations.length > 0) {
        this.setState({
          selectedConversation: filtredConversations[0],
          conversation: true,
          messageText: '',
          usersShown: false
        })
      } else {
        this.props
          .createConversation({
            variables: {
              usersIds: [user.id, this.props.user.id]
            }
          })
          .then(result => {
            this.setState({
              selectedConversation: result.data.createConversation,
              conversation: true,
              messageText: '',
              usersShown: false
            })
          })
      }
    }
  }

  sendMessage = state => {
    let messages = this.state.selectedConversation.messages.map(message => {
      return {
        senderId: message.sender.id,
        recipientId: message.recipient.id,
        text: message.text
      }
    })

    let recipientId = this.state.selectedConversation.users
      .map(user => {
        return user.id
      })
      .find(id => {
        return id !== this.props.user.id
      })

    messages.push({
      senderId: this.props.user.id,
      recipientId: recipientId,
      text: state.html
    })

    let files = state.files.slice()

    let promises = files.map(file => {
      return new Promise((resolve, reject) => {
        let data = new FormData()
        data.append('data', file)
        resolve(
          fetch('https://api.graph.cool/file/v1/cj7yw71n11upj01471m9o0b16', {
            method: 'POST',
            body: data
          })
        )
      }).then(res => res.json())
    })

    Promise.all(promises)
      .then(result => {
        return result.map(file => file.id)
      })
      .then(fileIds => {
        return this.props.createMessage({
          variables: {
            senderId: this.props.user.id,
            recipientId: recipientId,
            text: state.html,
            filesIds: fileIds,
            conversationId: this.state.selectedConversation.id,
            status: 'Unread'
          }
        })
      })
      .then(() => {
        this.props.updateParentState(this.state)
      })
  }

  render() {
    const { data, user, showChatBox, conversations } = this.props
    return (
      <div className="conversation-list">
        {this.state.conversation ? (
          <Conversation
            showConversationList={this.showConversationList}
            openMessage={this.showConversation}
            selectedConversation={this.state.selectedConversation}
            user={user}
            sendMessage={this.sendMessage}
            messageText={this.state.messageText}
            id={this.state.selectedConversation.id}
          />
        ) : (
          <div>
            <div className={this.state.usersShown ? 'users' : 'hidden'}>
              Select user:
              {data.allUsers && data.allUsers.length
                ? data.allUsers
                    .filter(systemUser => {
                      return systemUser.id !== this.props.user.id
                    })
                    .map((systemUser, index) => (
                      <div className="users__available-user" onClick={() => this.goToConversation(systemUser)} key={index}>
                        {_.get(systemUser.userProfile, 'firstName', '') + ' ' + _.get(systemUser.userProfile, 'lastName', '')}
                      </div>
                    ))
                : ''}
            </div>
            <div className="message-box__header">
              <i className="icon-search" onClick={this.showUsers} />
              <i className="icon-close" onClick={showChatBox} />
            </div>
            <div className="conversation-wrapper">
              {conversations
                ? conversations.map(conversation => (
                    <ListItem
                      key={conversation.id}
                      id={conversation.id}
                      img={'/img/user.svg'}
                      user={conversation.users
                        .filter(participant => {
                          return participant.id !== user.id
                        })
                        .map(participant => {
                          return participant.userProfile?(participant.userProfile.firstName + ' ' + participant.userProfile.lastName):''
                        })}
                      userMessage={
                        conversation.messages.length ? converter.convert(conversation.messages[conversation.messages.length - 1].text) : ''
                      }
                      conversationDate={
                        conversation.messages.length
                          ? moment(conversation.messages[conversation.messages.length - 1].createdAt).calendar(null, {
                              sameDay: function() {
                                return moment
                                  .utc(this)
                                  .local()
                                  .format('HH:mm')
                              },
                              lastDay: function() {
                                return '[Yesterday]'
                              },
                              lastWeek: function() {
                                return moment(this).format('MM.DD.YY')
                              }
                            })
                          : ''
                      }
                      unreadMessagesAmount={
                        conversation.messages.filter(message => {
                          return message.status === 'Unread' && message.sender.id !== user.id
                        }).length
                      }
                      openMessage={this.showConversation}
                      conversation={conversation}
                    />
                  ))
                : []}
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default compose(
  graphql(CONVERSATIONS_LIST, {
    name: 'conversationsList',
    options: props => ({
      variables: {
        userId: props.user ? props.user.id : ''
      },
      fetchPolicy: 'network-only'
    })
  }),
  graphql(CREATE_MESSAGE, {
    name: 'createMessage'
  }),
  graphql(UPDATE_MESSAGE, {
    name: 'updateMessage'
  }),
  graphql(CREATE_CONVERSATION, {
    name: 'createConversation'
  }),
  graphql(USERS, {
    options: props => ({
      fetchPolicy: 'network-only'
    })
  })
)(ConversationList)



// WEBPACK FOOTER //
// src/components/Chat/ConversationList.jsx